import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/components/layout.vue'
// import ValidUser from '@components/ValidUser.vue'
import Login from '@/pages/login/index.vue'
import Print from '@/pages/components/Print/index.vue'
import SpecialProcess from '@/pages/components/special-process/index.vue'

// 处理重复进入路由报错
const originaPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originaPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

// ！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！
// 如果需要在首页的content打开， 需要在layout组件中配置路由名称 ---- 暂时废弃

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: { name: '/dashboard' },
  },
  {
    path: '/dashboard',
    name: '/dashboard',
    meta: {
      label: '首页',
    },
    component: () => import('@/pages/components/dashboard/index.vue'),
  },
  {
    path: '/lc-iframe',
    name: 'lc-iframe',
    meta: {
      multipleTab: true
    },
    component: () => import('@/components/lcIframe.vue'),
  },
  {
    path: '/wash-label',
    component: () => import('@/pages/components/washLabel/index.vue'),
    children: [
      {
        path: 'list',
        name: 'wash-label/list',
        meta: {
          label: '版房洗水唛打印',
        },
        component: () => import('@/pages/components/washLabel/list/index.vue'),
      }
    ]
  },
  {
    path: '/invoice-allocate',
    component: () => import('@/pages/components/invoice-allocate/index.vue'),
    children: [
      {
        path: 'list',
        name: 'invoice-allocate/list',
        meta: {
          label: '预制发票-分摊金额',
        },
        component: () => import('@/pages/components/invoice-allocate/list/index.vue'),
      },
      
    ]
  },
  {
    path: '/order-manual',
    name: 'order-manual',
    component: () => import('@/pages/components/order-manual/index.vue'),
    meta: {
      label: '过单手册',
    }
  },
  {
    path: '/tag-info',
    name: 'tag-info',
    component: () => import('@/pages/components/tag-info/index.vue'),
    meta: {
      label: '吊牌信息维护',
    }
  },
  {
    path: '/material-category',
    name: 'material-category',
    component: () => import('@/pages/components/material-category/index.vue'),
    meta: {
      label: '商品类目',
    }
  },
  {
    path: '/masterData-feature',
    name: 'masterData-feature',
    component: () => import('@/pages/components/masterData-feature/index.vue'),
    meta: {
      label: '颜色/尺码',
    },
  },
  {
    path: '/store-issue',
    name: 'store-issue',
    meta: {
      label: '发料列表',
    },
    component: () => import('@/pages/components/material-out/search/index.vue'),
  },
  {
    path: '/material-in',
    name: 'material-in',
    meta: {
      label: '退料列表',
      rootType: 1
    },
    component: () => import('@/pages/components/material-in/index.vue'),
  },
  {
    path: '/goods-inspection',
    component: () => import('@/pages/components/goods-inspection/index.vue'),
    children: [
      {
        path: 'list',
        name: 'goods-inspection/list',
        component: () => import('@/pages/components/goods-inspection/list/index.vue'),
        meta: {
          label: '退货质检',
        },
      }],
  },
  {
    path: '/cmt-adjust',
    component: () => import('@/pages/components/cmt-adjust/index.vue'),
    children: [
      {
        path: 'list',
        name: 'cmt-adjust/list',
        component: () => import('@/pages/components/cmt-adjust/list/index.vue'),
        meta: {
          label: 'CMT-耗量调整',
          keepAlive: true
        },
      },
      {
        path: 'detail/:type',
        name: 'cmt-adjust/detail',
        component: () => import('@/pages/components/cmt-adjust/detail/index.vue'),
        meta: {
          children: [
            {
              reg: 'creat',
              label: '新建调整单'
            }, {
              reg: 'edit',
              label: '编辑/查看'
            }]
        },
      },

    ],
  },
  {
    path: '/advance-order',
    component: () => import('@/pages/components/advance-order/index.vue'),
    children: [
      {
        path: 'list',
        name: 'advance-order/list',
        component: () => import('@/pages/components/advance-order/list/index.vue'),
        meta: {
          label: '采购订单-预付款',
        },
      },
    ],
  },
  {
    path: '/planned-cost',
    name: 'planned-cost',
    meta: {
      label: '成控核算看板',
    },
    component: () => import('@/pages/components/planned-cost/index.vue'),
    children: [
      {
        path: 'board',
        name: 'planned-cost/board',
        component: () => import('@/pages/components/planned-cost/search/index.vue'),
        meta: {
          label: '成控核算看板',
        },
      },
    ]
  },
  {
    path: '/estimated-cost',
    name: 'estimated-cost',
    meta: {
      label: '预控成本看板',
    },
    component: () => import('@/pages/components/estimated-cost/index.vue'),
  },

  {
    path: '/evaluate-list',
    name: 'evaluate-list',
    component: () => import('@/pages/components/evaluate-list/index.vue'),
    meta: {
      label: '供应商准入评分表',
    },
  },
  {
    path: '/evaluate-edit',
    name: 'evaluate-edit',
    component: () => import('@/pages/components/evaluate-list/edit.vue'),
    meta: {
      label: '新建/编辑',
    },
  },
  {
    path: 'vendor-rule',
    component: () => import('@/pages/components/vendor-rule/index.vue'),
    meta: {
      label: '供应商准入规则'
    },
    children: [
      {
        path: 'list',
        component: () => import('@/pages/components/vendor-rule/list/index.vue'),
        meta: {
          label: '供应商准入规则列表'
        },
      },
      {
        path: 'edit',
        component: () => import('@/pages/components/vendor-rule/edit/index.vue'),
        meta: {
          label: '新增/编辑'
        },
      }
    ]
  },
  {
		path: 'vendor-apply',
		component: () => import('@/pages/components/vendor-apply/index.vue'),
		children: [
			{
				path: 'list',
        component: () => import('@/pages/components/vendor-apply/list/index.vue'),
				meta: {
					label: '供应商准入列表',
				},
			}
		]
	},


  // 报表
  {
    path: '/fabric-inventory',
    name: 'fabric-inventory',
    meta: {
      label: '面料库存查询',
    },
    component: () => import('@/pages/components/fabric-inventory/index.vue'),
  },
  {
    path: '/financial-statement',
    name: 'financial-statement',
    meta: {
      label: '财务结算报表',
    },
    component: () => import('@/pages/components/financial-statement/index.vue'),
  },
  {
    path: '/account-pay',
    name: 'account-pay',
    meta: {
      label: '快速应付帐款对账单',
    },
    component: () => import('@/pages/components/account-pay/index.vue'),
  },
  {
    path: '/purchase-record',
    name: 'purchase-record',
    meta: {
      label: '采购记录查询',
    },
    component: () => import('@/pages/components/purchase-record/index.vue'),
  },
  {
    path: '/currency-rate',
    name: 'currency-rate',
    component: () => import('@/pages/components/currency-rate/index.vue'),
    meta: {
      label: '货币转换汇率报表'
    }
  },
  {
    path: '/order-ship-export',
    name: 'order-ship-export',
    component: () => import('@/pages/components/order-ship-export/index.vue'),
    meta: {
      label: '订货板及船样板报表'
    }
  },
  {
    path: '/fabric-out-item-export',
    name: 'fabric-out-item-export',
    component: () => import('@/pages/components/fabric-out-item-export/index.vue'),
    meta: {
      label: '面辅料出仓明细报表'
    }
  },
  {
		path: '/download-example',
		meta: {
			label: '模板下载'
		},
    component: () => import('@/pages/components/download-example/index.vue'),
		name: '模板下载'
	},
  {
		path: '/totalQ-inspection',
		meta: {
			label: '总Q质检'
		},
    component: () => import('@/pages/components/totalQ-inspection/index.vue'),
		name: '总Q检验'
	},
  {
    name: '404', //其他找不到的404页面，这个路由放在最后
    path: '*',
    component: () => import('@/components/notFound.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    // {
    //   path: '/lcscm',
    //   name: 'lcscm',
    //   component: Layout,
    //   children: [
    //     {
    //       path: '*',
    //       name: '/lcscm/*',
    //       component: () => import('@/components/sub-vue.vue'),
    //     }
    //   ]
    // },
    // {
    //   path: '/lcscmcost',
    //   name: 'lcscmcost',
    //   component: Layout,
    //   children: [
    //     {
    //       path: '*',
    //       name: '/lcscmcost/*',
    //       component: () => import('@/components/sub-vue.vue'),
    //     }
    //   ]
    // },
    // {
    //   path: '/lcscmuser',
    //   name: 'lcscmuser',
    //   component: Layout,
    //   children: [
    //     {
    //       path: '*',
    //       name: '/lcscmuser/*',
    //       component: () => import('@/components/sub-vue.vue'),
    //     }
    //   ]
    // },
    // {
    //   path: '/lcscmdata',
    //   name: 'lcscmdata',
    //   component: Layout,
    //   children: [
    //     {
    //       path: '*',
    //       name: '/lcscmdata/*',
    //       component: () => import('@/components/sub-vue.vue'),
    //     }
    //   ]
    // },
    // {
    //   path: '/validUser',
    //   name: 'validUser',
    //   component: ValidUser
    // },
    {
      path: '/trendy-print',
      name: 'trendy-print',
      component: Print,
    },
    {
      path: '/hiPrint',
      name: 'hiPrint',
      component: () => import('@/pages/components/Print/modules/hiPrint/index.vue'),
    },
    {
      path: '/production-process',
      name: 'production-process',
      component: SpecialProcess,
      meta: {
        label: '生产工艺单查询',
        rootType: 1,
        newWindow: true,
      },
    },
    {
      path: '/progress-schedule',
      name: 'progress-schedule',
      component: () => import('@/pages/components/progress-schedule/index.vue'),
      meta: {
        label: '进度看板',
      },
    },
    {
      path: '/vendor-apply/declaration-Info/apply',
      component: () => import('@/pages/components/vendor-apply/declaration-Info/index.vue'),
      meta: {
        label: '申请单信息',
      },
    },
    {
      path: '/vendor-apply/print',
      component: () => import('@/pages/components/vendor-apply/list/modules/print/index.vue'),
    },
    {
      path: '/invoice-allocate/detail/:type',
      name: 'invoice-allocate/detail',
      component: () => import('@/pages/components/invoice-allocate/detail/index.vue'),
      meta: {
        children: [
          {
            reg: 'creat',
            label: '预制发票-新增分摊金额'
          }, {
            reg: 'edit',
            label: '预制发票-编辑分摊金额'
          }, {
            reg: 'view',
            label: '预制发票-查看分摊金额'
          }]
      },
    },
    {
      path: '/advance-order/detail/:type',
      name: 'advance-order/detail',
      component: () => import('@/pages/components/advance-order/detail/index.vue'),
      meta: {
        keepAlive: false,
        children: [
          {
            reg: 'creat',
            label: '预付款-新增'
          }, {
            reg: 'edit',
            label: '预付款-编辑'
          },
          {
            reg: 'view',
            label: '预付款-查看'
          }
        ]
      },
    },
    // 写在最后
    {
      path: '/',
      name: 'home',
      component: Layout,
      children: routes
    },
  ]
})

export default router
